import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";

export const CALCULATION_TOLL_EDIT_FORM_SCHEMA = yup.object().shape({
  fromCcm: yup.string().required('Molimo Vas da ccm od'),
  toCcm: yup.string().required('Molimo Vas da ccm do'),
  price: yup.string().required('Molimo Vas da cijenu'),
});

